import { Component, inject, OnDestroy, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { of, Subscription } from 'rxjs';
import { EditComponent } from "../edit.component";
import { ActivatedRoute } from "@angular/router";
import { EventManager } from "src/app/core";
import { NzModalRef, NZ_MODAL_DATA } from "ng-zorro-antd/modal";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: 'otp',
  templateUrl: "./otp.component.html",
  styleUrls: ["./otp.component.scss"]
})

export class OTPComponent extends EditComponent implements OnInit, OnDestroy  {
    @Output() result: EventEmitter<any> = new EventEmitter();
    @Input() data: any = {};
    @Input() func: any;
    @Input() type: any;
    @Input() broadcast: any;
    @Input() defaultTime = 90;
    otp: string = '';
    failTimes = 0;
    countdown = 10;
    myInterval: any;
    accountInfo: any;
    subscription: Subscription[] = [];
    isInvalidOTP: boolean = false;
    isHasClose: boolean = false;
    readonly nzModalData: any = inject(NZ_MODAL_DATA);
    constructor(
        public eventManger: EventManager,
        public route: ActivatedRoute,
        private modalRef : NzModalRef,
    ) {
        super(eventManger, route);
    }
    ngOnInit() {
        this.type = this.nzModalData.type;
        super.ngOnInit();
        this.subscription = [
            this.eventManger.subscribe('close-modal', (res) => {this.dismiss()}),
            this.eventManger.subscribe('invalid-otp', (res) => {this.isInvalidOTP = true;}),
        ];
    }
    ngOnDestroy() {
        this.eventManger.destroys(this.subscription);
    }
    dismiss() {
        this.modalRef.close();
    }
    validate() {
        return this.otp && this.otp.length === 6;
    }
    confirm() {
        if (!this.validate()) {
            return of(false);
        }
        this.result.emit(this.data);
        this.isInvalidOTP = false;
        this.eventManager.broadcast({
            name: 'result-otp',
            content: {
                otp: this.otp,
                type: this.type
            }
        });
        this.dismiss();
    }
    cancel() {
        this.result.emit(null);
    }
}
